/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
const { toCamelCase } = require("js-convert-case");

export interface IPreviewTemplateMethods extends IPluginMethodMap {
  getPreviewTemplateSync(args: any): any;
}

export class PreviewTemplateService implements IAgentPlugin {
  readonly methods: IPreviewTemplateMethods;
  constructor() {
    this.methods = {
      getPreviewTemplateSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    const result: any = {
      preview: {},
    };
    result.preview.credentialName = args?.credentialMeta?.templateName;
    result.preview.credentialLogo = args?.credentialMeta?.templateLogo?.base64;
    result.preview.credentialDescription =
      args?.credentialMeta?.templateDescription;
    const credentialFields = this.getCredentialFields(args);
    result.jsonFormat = this.createJsonFormat(
      args?.credentialMeta,
      credentialFields
    );
    result.jsonldFormat = this.createJsonldFormat(args);

    const credFieldsForPreview = this.getCredentialFields(args);
    result.preview.credentialFields =
      this.formatForPreview(credFieldsForPreview);
    return result;
  }

  private createJsonldFormat(args: any) {
    //TODO: JSONLD Format
    return {};
  }

  private formatForPreview(credentialFields: any = []) {
    const credFields: any = [];
    credentialFields?.forEach((cred: any, index: number) => {
      if (cred?.compProps) {
        credFields.push(cred);
        credFields[index].compProps.required = false;
      }
    });
    return credFields ?? [];
  }

  private createJsonFormat(credentialMeta: any, credentialFields: any) {
    return {
      name: credentialMeta?.templateName,
      description: credentialMeta?.templateDescription,
      credential: credentialFields,
    };
  }

  private getCredentialFields(args: any) {
    let comp: any = [];
    const credSub: any[] = [...(args?.credentialSubject[0]?.cards ?? [])];
    for (const cred of credSub) {
      if (cred?.title) {
        if (
          cred?.attributeType === "radio" &&
          typeof cred?.attributeOptions === "string" &&
          cred?.attributeOptions &&
          cred?.attributeOptions !== ""
        ) {
          cred.attributeOptions = cred?.attributeOptions?.split(",");
        }
        const compProps: any = {
          id: toCamelCase(cred?.title ?? ""),
          label: cred?.title,
          required: cred?.isRequired,
          options: cred?.attributeOptions,
        };
        comp.push({
          type: cred?.attributeType,
          compProps: { ...compProps },
        });
      }
    }
    if (comp?.length) {
      comp = [...comp, ...this.addValidity()];
    }

    comp = [...comp, ...this.checkForEvidences(args)];
    return comp;
  }

  private addValidity() {
    const comp: any = [];
    comp.push({
      type: "dateTimePicker",
      compProps: {
        id: "validFrom",
        label: "Valid From",
        required: true,
      },
    });
    comp.push({
      type: "dateTimePicker",
      compProps: {
        id: "validUntil",
        label: "Valid Until",
        required: false,
      },
    });
    return comp;
  }

  private checkForEvidences(args: any) {
    const comp: any = [];
    const credSub: any[] = args?.credentialEvidence[0]?.cards ?? [];
    for (const cred of credSub) {
      if (cred?.title) {
        comp.push({
          type: "fileDropZone",
          compProps: {
            id: toCamelCase(cred?.title ?? ""),
            label: cred?.title,
            required: true,
            maxFiles: 1,
          },
        });
      }
    }
    return comp;
  }
}
